import { render, staticRenderFns } from "./youxuan.vue?vue&type=template&id=0494b425"
import script from "./youxuan.vue?vue&type=script&lang=js"
export * from "./youxuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports